import { render } from "./CarCareTop.vue?vue&type=template&id=515efb0e"
import script from "./CarCareTop.vue?vue&type=script&lang=js"
export * from "./CarCareTop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v2/CarCareTop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "515efb0e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('515efb0e', __exports__)) {
    api.reload('515efb0e', __exports__)
  }
  
  module.hot.accept("./CarCareTop.vue?vue&type=template&id=515efb0e", () => {
    api.rerender('515efb0e', render)
  })

}


export default __exports__